export const SITE_TITLE = "JASTER — ИГЛА"
